{
  class SeamlessMarquee extends HTMLElement {
    connectedCallback() {
      if(window.coolHelperFunctions.prefersReducedMotion()){
        return false;
      }

      const speed = parseFloat(this.getAttribute('speed')) || 50;
      const pauseOnHoverAttribute = this.getAttribute('pause-on-hover')
      const pauseOnHover = !(pauseOnHoverAttribute == "false" || pauseOnHoverAttribute == 0)

      // Make the marquee focusable for keyboard accessibility
      this.setAttribute('tabindex', '0');
      this.setAttribute('role', 'marquee');
      this.setAttribute('aria-live', 'off');

      this.style.overflow = 'hidden';
      this.style.display = 'block';
      this.style.whiteSpace = 'nowrap';

      const wrapper = document.createElement('div');
      wrapper.style.display = 'inline-flex';
      wrapper.style.willChange = 'transform';

      const content = document.createElement('div');
      content.style.display = 'inline-flex';
      content.style.flex = '1 0 auto';
      content.style.alignItems = 'center';

      while (this.firstChild) content.appendChild(this.firstChild);
      wrapper.appendChild(content);

      this.appendChild(wrapper);

      const onReady = () => {
        const containerWidth = this.offsetWidth;
        const contentWidth = content.offsetWidth;

        // Always clone at least once for smooth looping
        wrapper.appendChild(content.cloneNode(true));

        // Clone more if content is small
        while (wrapper.offsetWidth < containerWidth * 2) {
          wrapper.appendChild(content.cloneNode(true));
        }

        let pos = 0;
        let last = performance.now();
        let paused = false;
        let running = false;

        if (pauseOnHover) {
          this.addEventListener('mouseenter', () => paused = true);
          this.addEventListener('mouseleave', () => paused = false);
          this.addEventListener('focus', () => paused = true);
          this.addEventListener('blur', () => paused = false);
        }

        const totalWidth = contentWidth;

        const loop = (now) => {
          if (!running) return;
          if (!paused) {
            const delta = (now - last) / 1000;
            pos -= speed * delta;
            if (-pos >= totalWidth) pos += totalWidth;
            wrapper.style.transform = `translate3d(${pos}px, 0, 0)`;
          }
          last = now;
          requestAnimationFrame(loop);
        };

        const observer = new IntersectionObserver(([entry]) => {
          running = entry.isIntersecting;
          if (running) {
            last = performance.now();
            requestAnimationFrame(loop);
          }
        }, { threshold: 0 });

        observer.observe(this);

        requestAnimationFrame(loop);
      };

      // requestAnimationFrame(() => requestAnimationFrame(onReady));
      const images = content.querySelectorAll('img[loading="lazy"]');
      images.forEach(img => {
        img.loading = 'eager';
        if (!img.complete) img.decoding = 'sync';
      });

      Promise.all([...images].map(img => {
        if (img.complete) return Promise.resolve();
        return new Promise(res => img.onload = img.onerror = res);
      })).then(() => {
        requestAnimationFrame(() => requestAnimationFrame(onReady));
      });
    }
  }
  customElements.define('seamless-marquee', SeamlessMarquee);
}